/**
 * Authentication and verification constants
 * Using environment variables for sensitive information
 */

// Cloudflare Turnstile keys
export const TURNSTILE_SITE_KEY = import.meta.env
  .VITE_TURNSTILE_SITE_KEY as string;
// Note: Secret key should be used server-side only
export const TURNSTILE_SECRET_KEY = import.meta.env
  .VITE_TURNSTILE_SECRET_KEY as string;

// Email dashboard verification
export const EMAIL_DASHBOARD_EMAIL = "iam123admin@numberz.au";
export const EMAIL_DASHBOARD_PASSWORD = "R@dm!nNumberz";
export const EMAIL_DASHBOARD_VERIFICATION_KEY = "emailDashboardVerified";
